import { Controller, Payload } from "../../controller";
import { ApplicationState } from "../../store";
import { bindActionCreators, Dispatch } from "redux";

import { Item ,initialValueState, ItemState, ItemActions } from "./item.model"
import { put, takeLatest } from "redux-saga/effects";
import { configController } from "../config/config.controll";
import { action } from "typesafe-actions";

export interface ItemViewProps{
    itemState:ItemState
    itemActions:ItemActions
}


class ItemController extends Controller<Item, ItemState, ItemActions> {
    constructor() {
        super(initialValueState.row.type,initialValueState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes
            setTabelaPrecoSelected:`@${this.moduloName}/SET_TABELA_PRECO_SELECTED`,
        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
            setTabelaPrecoSelected:(tabela) => action(this.actionsType.setTabelaPrecoSelected, { tabela }),

        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects
            takeLatest(this.actionsType.resultAfterEffcts, this.resultAfterItemEffcts),
            takeLatest(this.actionsType.setTabelaPrecoSelected, this.resultAfterSetTabelaPrecoSelected.bind(this)),

        ]
    }

    private* resultAfterSetTabelaPrecoSelected(actions:Payload){
        yield put(this.reducer.resultAfterEffects(
            {...this.state,tabela_preco_selected:actions.payload.tabela},
            this.actionsType.setTabelaPrecoSelected
        ))                                    
    }

    private* resultAfterItemEffcts(actions:Payload){
        const vm = actions.payload.this as Controller<Item, ItemState, ItemActions>;
        try {
            let actionType = actions.payload.actionType;
            let state:ItemState = actions.payload.result;
            if(state.status === "ok"){
                switch (actionType) {
                    case vm.actionsType.create:
                        //verificar se o item tem o codigo
                        if(state.row.codigo === ""){
                            yield put(configController.reducer.actions.gerarCodigoItem(state.row))
                        }
                        break;                
                }
            }
        } catch (error:any) {
            console.log("error resultAfterItemEffcts",error);
            let msg = "Ops, ocorreu uma falha em resultAfterItemEffcts, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error 
            yield put(vm.reducer.resultAfterEffects(
                {...vm.state,loading:false,msg:err,status:"error",error:true,showAlert:true},
                vm.actionsType.resultAfterItemEffcts
            ))                                    
        }

    }
}


export const itemController = new ItemController()

export const mapStateToItemProps = (state: ApplicationState) => ({
    itemState: state.itemState,
})

export const mapDispatchToItemProps = (dispatch: Dispatch) => ({
    itemActions: bindActionCreators({...itemController.reducer.actions}, dispatch),
})